"use client";

import type { EventNameType } from "@homeinstead/shared";
import type { EventPayload } from "../types";

import { enqueueTrack } from "./analytics-event-queue";
import { getAnalyticsInstance } from "./get-analytics-instance";

type TrackOptions = {
  transport?: "sendBeacon";
};

function track(
  eventName: EventNameType,
  properties?: EventPayload,
  options?: TrackOptions,
): void {
  const analytics = getAnalyticsInstance({ eventType: "track" });
  if (!analytics) {
    return;
  }

  enqueueTrack(analytics, eventName, properties, options?.transport);
}

export { track };
